import React from 'react';
import { Link as Anchor } from "react-router-dom";
import './BuscarCeroKm.css';

export default function BuscarCeroKm() {
    return (
        <section className='buscar-cero-km-section'>
            <div className='buscar-cero-km-container'>
                <div className='buscar-cero-km-text'>
                    <h2 className='buscar-cero-km-title'>ENCONTRA TU PROXIMO 0KM</h2>
                    <p className='buscar-cero-km-subtitle'>
                        Descubrí todas las marcas con la mejor financiación y garantía de fábrica.
                    </p>
                    <div className='buscar-cero-km-features-grid'>
                        <div className='feature-item'>
                            <span className='feature-icon-container'>
                                <i className='fas fa-handshake'></i>
                            </span>
                            <p className='feature-text'>Financiación a tu medida</p>
                        </div>
                        <div className='feature-item'>
                            <span className='feature-icon-container'>
                                <i className='fas fa-shield-alt'></i>
                            </span>
                            <p className='feature-text'>Garantía oficial</p>
                        </div>
                        <div className='feature-item'>
                            <span className='feature-icon-container'>
                                <i className='fas fa-truck-moving'></i>
                            </span>
                            <p className='feature-text'>Entrega inmediata</p>
                        </div>
                    </div>
                    <Anchor to="/stock/autos" className='buscar-cero-km-btn'>
                        Explorar opciones
                    </Anchor>
                </div>
            </div>
        </section>
    );
}